<template>
  <div class="row">
    <div class="col-12 mt-4 mb-2 mb-md-4">
      <div class="row">
        <div class="col-12 col-md-4 mb-3">
          <div class="form-inline justify-content-center justify-content-md-start">
            <div class="form-group mb-2">
              <label for="inputBusca" class="sr-only">Busca</label>
              <input type="text" class="form-control" id="inputBusca" @keypress="selecionarUsuario" v-model="usuario"
                     placeholder="Buscar usuário">
            </div>
            <button type="button" class="btn btn-secondary btn-busca mb-2 ml-2" @click="buscarUsuario"><i
              class="fas fa-search"></i></button>
          </div>
        </div>
        <div class="col-12 col-md-4 mb-3">
          <div class="d-flex align-items-center justify-content-center usuario-selec">
            <i class="fas fa-user-circle"></i>
            <p v-if="usuarioSelecionado">{{ usuarioSelecionado }}</p>
            <p v-else>Nenhum usuário selecionado</p>
          </div>
        </div>
        <div class="col-12 col-md-4 mb-3">
          <div class="d-flex align-items-center justify-content-center justify-content-md-end filtro-data">
            <date-range-picker
              ref="picker"
              :auto-apply="true"
              opens="left"
              v-model="dateRange"
              :locale-data="dateRangeLocale"
              :ranges="filtrosDateRangePredefinidos"
              @update="atualizarDashboard">
            </date-range-picker>
          </div>
        </div>
      </div>

    </div>
    <div class="col-12 mb-3 mb-md-5" ref="chartAcessoMedioTopicos">
      <div class="grafico">
        <h2><i class="fas fa-chart-line"></i> Acesso médio</h2>
        <div class="ct-chart ct-major-eleventh mt-3" id="chart4"></div>
      </div>
    </div>
    <div class="col-12 col-md-4 mb-3" ref="chartVideosAssistidos">
      <div class="grafico">
        <h2><i class="fas fa-chart-bar"></i> Vídeos assistidos (em mins)</h2>
        <div class="ct-chart ct-major-eleventh mt-3" id="chart5"></div>
      </div>
    </div>
    <div class="col-12 col-md-4 mb-3" ref="chartRespostas">
      <div class="grafico">
        <h2><i class="fas fa-chart-bar"></i> Questões respondidas</h2>
        <div class="ct-chart ct-major-eleventh mt-3" id="chart6"></div>
      </div>
    </div>
    <div class="col-12 col-md-4 mb-3" ref="chartDownloads">
      <div class="grafico">
        <h2><i class="fas fa-chart-bar"></i> Downloads realizados</h2>
        <div class="ct-chart ct-major-eleventh mt-3" id="chart7"></div>
      </div>
    </div>
    <div class="col-12 mb-3 mt-3 mb-md-5" ref="chartDesempenho">
      <div class="grafico">
        <div class="d-flex justify-content-between align-items-center">
          <h2><i class="fas fa-chart-bar"></i> Desempenho</h2>
          <div class="form-group">
            <label for="graf2">visualizar por</label>
            <select id="graf2" v-model="visualizacaoGraficoDesempenho" @change="exibirGraficoDesempenho">
              <option value="disciplinas">Disciplina</option>
              <option value="cursos">Curso</option>
            </select>
          </div>
        </div>

        <div class="col-12 col-md-12">
          <ul class="ct-legend">
            <li class="ct-series-erradas">Média de erros</li>
            <li class="ct-series-certas">Média de acertos</li>
            <li class="ct-series-erradas-usuario" v-if="usuarioSelecionado">Erros do usuário</li>
            <li class="ct-series-certas-usuario" v-if="usuarioSelecionado">Acertos do usuário</li>
          </ul>
        </div>
        <div class="chart-container ct-golden-section">
          <div id="chart8"></div>
          <div class="mt-4" id="chart8-compare"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import 'chartist/dist/chartist.min.css'
import Chartist from 'chartist'
import DateUtils from '@/core/util/date-utils'
import DashboardAPI from '@/api/dashboard-api'
import DateRangePicker from 'vue2-daterange-picker/src/components/DateRangePicker'
import moment from 'moment'
import AxiosConfig from '@/config/axios-config'
import ResponseUtils from '@/core/util/response-utils'
import UsuarioAPI from '@/api/usuario-api'
import ChartistPluginBarLabel from '@/core/plugins/chartist-plugin-bar-label'
import StringUtils from '@/core/util/string-utils'
import Swal from 'sweetalert2'

window['Chartist'] = Chartist

require('chartist-plugin-legend')

const graficoDesempenhoOnDraw = data => data.type === 'bar' ? data.element.attr({ style: 'stroke-width: 15px' }) : ''
const graficoDesempenhoOnData = context => {
  const seriesList = context.data.series

  const stackTotals = []
  seriesList.forEach(series => {
    series.data.forEach((value, valueIndex) => {
      stackTotals[valueIndex] = stackTotals[valueIndex] || 0
      stackTotals[valueIndex] += value
    })
  })

  seriesList.forEach(series => {
    if (series.name === 'Corretas') {
      series.totals = []
      series.data.forEach((value, index) => {
        series.totals.push(stackTotals[index])
      })
    }
  })

  context.data.series.forEach(series => {
    series.data = series.data.map((value, valueIndex) => (value * 100) / stackTotals[valueIndex])
  })
}

export default {
  name: 'DashboardUsuarios',
  components: { DateRangePicker },
  data () {
    return {
      usuario: '',
      usuarioSelecionado: '',
      visualizacaoGraficoDesempenho: 'disciplinas',
      dateRange: {
        startDate: DateUtils.formatDate(DateUtils.create().subtract(30, 'days').toDate()),
        endDate: DateUtils.formatDate(new Date())
      },
      filtrosDateRangePredefinidos: {
        'Esta semana': [moment().startOf('week'), moment().endOf('week')],
        'Última semana': [moment().subtract(1, 'week').startOf('week'), moment().subtract(1, 'week').endOf('week')],
        'Este mês': [moment().startOf('month'), moment().endOf('month')],
        'Último mês': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
        'Este ano': [moment().startOf('year'), moment().endOf('year')]
      },
      dateRangeLocale: {
        direction: 'ltr',
        format: 'DD/MM/YYYY',
        separator: ' - ',
        daysOfWeek: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
        monthNames: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez']
      }
    }
  },

  mounted () {
    this.carregarGraficos()
  },

  methods: {
    selecionarUsuario: function (event) {
      if (event.key === 'Enter') this.buscarUsuario()
    },

    buscarUsuario: function () {
      const loader = this.$loading.show()
      UsuarioAPI.obterPorEmail(this.usuario).then(() => {
        this.usuarioSelecionado = this.usuario
        this.carregarGraficos()
      }).catch(error => {
        const errorData = ResponseUtils.getErrorData(error)
        if (errorData && errorData.email) {
          Swal.fire({
            icon: 'error',
            text: errorData.email
          })
        } else {
          ResponseUtils.handleError(error, loader)
        }
      }).then(() => loader.hide())
    },

    carregarGraficos: function () {
      this.exibirGraficoVideosAssistidos()
      this.exibirGraficoRespostas()
      this.exibirGraficoDownloads()
      this.exibirGraficoDesempenho()
      this.exibirGraficoAcessoMedio()
    },

    exibirGraficoDesempenho: function () {
      if (this.visualizacaoGraficoDesempenho === 'disciplinas') {
        this.carregarGraficoDesempenhoPorTipoVisualizacao(DashboardAPI.obterDesempenhoDisciplinas)
      } else if (this.visualizacaoGraficoDesempenho === 'cursos') {
        this.carregarGraficoDesempenhoPorTipoVisualizacao(DashboardAPI.obterDesempenhoCursos)
      }
    },

    carregarGraficoDesempenhoPorTipoVisualizacao: function (promiseRequest) {
      const limite = 5

      const loader = this.$loading.show({
        isFullPage: false,
        loader: 'spinner',
        container: this.$refs.chartDesempenho
      })

      promiseRequest(this.dateRange.startDate, this.dateRange.endDate, this.usuarioSelecionado).then(data => {
        if (data.length > limite) {
          data = data.slice(0, 5)
        }

        const options = {
          height: '530px',
          stackBars: true,
          horizontalBars: true,
          chartPadding: { right: 35 },
          axisY: { offset: 85 },
          axisX: { low: 0, high: 100, onlyInteger: true, labelInterpolationFnc: value => (value) + '%' },
          plugins: [ ChartistPluginBarLabel.create({ labelOffset: { y: 5 } }) ]
        }

        Chartist.Bar('#chart8', {
          labels: data.map(item => StringUtils.upperFirst(item.nome)),
          series: [
            { className: 'ct-series-erradas', name: 'Incorretas', data: data.map(item => item.media_erros) },
            { className: 'ct-series-certas', name: 'Corretas', data: data.map(item => item.media_acertos) }
          ]
        }, options)
          .on('data', graficoDesempenhoOnData)
          .on('draw', graficoDesempenhoOnDraw)

        if (this.usuarioSelecionado) {
          const optionsCompare = {
            height: '530px',
            stackBars: true,
            horizontalBars: true,
            reverseData: true,
            chartPadding: { right: 35 },
            axisY: { offset: 85, showLabel: false, showGrid: false },
            axisX: { low: 0, high: 100, showLabel: false, showGrid: false },
            plugins: [ ChartistPluginBarLabel.create({ labelOffset: { y: 5 } }) ]
          }

          Chartist.Bar('#chart8-compare', {
            series: [
              { className: 'ct-series-erradas-usuario', name: 'Incorretas', data: data.map(item => item.qt_erros_usuario) },
              { className: 'ct-series-certas-usuario', name: 'Corretas', data: data.map(item => item.qt_acertos_usuario) }
            ]
          }, optionsCompare)
            .on('data', graficoDesempenhoOnData)
            .on('draw', graficoDesempenhoOnDraw)
        }
      }).catch(error => ResponseUtils.handleError(error, loader))
        .then(() => loader.hide())
    },

    exibirGraficoVideosAssistidos: function () {
      const mapFunction = data => data.media_horas_usuarios

      this.exibirGraficoMedia(this.$refs.chartVideosAssistidos, '#chart5', DashboardAPI.obterMediaVideosAssistidos, mapFunction)
    },

    exibirGraficoRespostas: function () {
      const mapFunction = data => data.qtde_media_respostas

      this.exibirGraficoMedia(this.$refs.chartRespostas, '#chart6', DashboardAPI.obterMediaRespostas, mapFunction)
    },

    exibirGraficoDownloads: function () {
      const mapFunction = data => data.qtde_media_downloads

      this.exibirGraficoMedia(this.$refs.chartDownloads, '#chart7', DashboardAPI.obterMediaDownloads, mapFunction)
    },

    exibirGraficoMedia: function (container, chart, service, mapFunction) {
      const loader = this.$loading.show({ isFullPage: false, loader: 'spinner', container: container })

      service(this.dateRange.startDate, this.dateRange.endDate, this.usuarioSelecionado).then(data => {
        const chartData = mapFunction(data)

        const labels = chartData.map(item => DateUtils.formatDate(item.data, 'DD/MM YYYY'))
        const series = chartData.map(item => item.media)

        if (this.usuarioSelecionado) {
          const seriesUsuarioSelecionado = chartData.map(item => item.qt_usuario_selecionado)

          Chartist.Bar(chart,
            { labels: labels, series: [ series, seriesUsuarioSelecionado ] },
            {
              chartPadding: { top: 30 },
              plugins: [
                Chartist.plugins.legend({
                  legendNames: ['Média de usuários', 'Usuário escolhido'],
                  clickable: false
                })
              ]
            })
        } else {
          Chartist.Bar(chart, { labels: labels, series: [ series ] })
        }
      }).then(() => loader.hide())
    },

    exibirGraficoAcessoMedio: function () {
      const loader = this.$loading.show({ isFullPage: false, loader: 'spinner', container: this.$refs.chartAcessoMedioTopicos })

      DashboardAPI.obterAcessoMedioUsuariosTopicos(this.dateRange.startDate, this.dateRange.endDate, this.usuarioSelecionado).then(data => {
        const chartData = data.qtde_media_acessos

        const labels = chartData.map(item => DateUtils.formatDate(item.data, 'DD/MM YYYY'))
        const series = chartData.map(item => item.media)

        if (this.usuarioSelecionado) {
          const seriesUsuarioSelecionado = chartData.map(item => item.qt_usuario_selecionado)

          Chartist.Line('#chart4',
            { labels: labels, series: [ series, seriesUsuarioSelecionado ] },
            {
              chartPadding: { top: 30 },
              plugins: [
                Chartist.plugins.legend({
                  legendNames: ['Média de usuários', 'Usuário escolhido'],
                  clickable: false
                })
              ]
            })
        } else {
          Chartist.Line('#chart4', { labels: labels, series: [ series ] })
        }

        loader.hide()
      }).catch(error => ResponseUtils.handleError(error, loader))
    },

    atualizarDashboard: function () {
      this.dateRange.startDate = DateUtils.formatDate(this.dateRange.startDate)
      this.dateRange.endDate = DateUtils.formatDate(this.dateRange.endDate)

      this.carregarGraficos()
    }
  },

  destroyed () {
    AxiosConfig.cancelAll()
  }
}
</script>

<style>
  .chart-container {
    position: relative;
  }

  .chart-container > * {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  .ct-golden-section:before {
    padding-bottom: 0px;
  }
  .ct-golden-section:after {
    padding-bottom: 560px;
  }

  @media (max-width: 768px) {
    .ct-golden-section:after {
      padding-bottom: 700px;
    }
  }

  #chart8 .ct-series line, #chart8-compare .ct-series line {
    padding-right: 15px;
  }

  .ct-series-certas .ct-bar {
    stroke: #4DCDCC;
  }
  .ct-legend .ct-series-certas:before {
    background-color: #4DCDCC;
    border-color: #4DCDCC;
  }

  .ct-series-certas-usuario .ct-bar {
    stroke: #67DDD1;
  }
  .ct-legend .ct-series-certas-usuario:before {
    background-color: #67DDD1;
    border-color: #67DDD1;
  }

  .ct-series-erradas .ct-bar {
    stroke: #F47D3A;
  }
  .ct-legend .ct-series-erradas:before {
    background-color: #F47D3A;
    border-color: #F47D3A;
  }

  .ct-series-erradas-usuario .ct-bar {
    stroke: #F7B329;
  }
  .ct-legend .ct-series-erradas-usuario:before {
    background-color: #F7B329;
    border-color: #F7B329;
  }
</style>
